import React from 'react'
import { Table, DataTable, Chip, Icon } from '@arnsbogroup/react-voicearchive'
import { useHistory } from 'react-router-dom'
import AddMembers from './components/AddMembers'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'

const AgencyMembers = ( {agency, onChange = () => {}} ) => {
  if (!agency) {
    return null
  }
  const { formatMessage } = useIntl()
  const agencyHead = agency.agencySupplier.uid
  const history = useHistory()
  const Span = ({ children }) => <span>{ children }</span>
  const getStatusChip = ( status ) => (
    <Chip size="sm" state={{
      'BLOCKED': 'error',
      'INACTIVE': 'error',
      'ACTIVE': 'success',
      'APPLICANT': 'warning',
      'ONLINE': 'success',
      'IN REVIEW': 'warning',
      'ACCEPTED': 'warning',
      'ONBOARDING': 'warning',
      'REJECTED': 'error',
    }[status.toUpperCase()] ?? undefined}>
      <span className="capitalize">
        { status ? status.toLowerCase() : '' }
      </span>
    </Chip>
  )

  const onDelete = (entry) => {
    if (confirm(formatMessage(messages.onDeleteConfirm, { display_name: entry.display_name }))) {
      onChange({
        ...agency,
        members: agency.members.filter((el) => { return el.uid != entry.uid })
      })
    }
  }
  
  const onAgencyHeadChange = (entry) => {
    if (confirm(formatMessage(messages.onHeadChangeConfirm, { display_name: entry.display_name }))) {
      onChange({
        ...agency,
        newHeadOfAgency: entry
      })
    }
  }

  const Actions = (entry) => {
    return (
      <div className='flex flex-col-2 space-x-2'>
        <span
          title={formatMessage(messages.deleteMemberTitle)}
          className={agencyHead == entry.uid ? 'cursor-not-allowed' : 'cursor-pointer'}
          onClick={(event) => {
            event.stopPropagation()
            agencyHead == entry.uid ?
            undefined :
            onDelete(entry);
          }}
        >
          <Icon className={agencyHead == entry.uid ? 'text-gray-300' : 'text-negative'} icon={['fas', 'trash']} />
        </span>
        <span
          title={formatMessage(messages.changeAgencyHeadTitle)}
          className={agencyHead == entry.uid ? 'cursor-not-allowed' : 'cursor-pointer'}
          onClick={(event) => {
            event.stopPropagation()
            agencyHead == entry.uid ?
            undefined :
            onAgencyHeadChange(entry)
          }}
        >
          <Icon className={agencyHead == entry.uid ? 'text-warning' : 'text-gray-300'} icon={['fas', 'crown']} />
        </span>
      </div>
    )
  }

  return (
    <div className='mt-2'>
      <AddMembers agency={agency} onChange={onChange} />
      <DataTable
        components={{
          Tr: ({ childProps = {}, ...innerProps }) => {
            return (
              <Table.Tr onClick={childProps.uid ? () => history.push(`/suppliers/${childProps.uid}/overview`) : undefined}
                {...innerProps }
              />
            )
          },
          Td: ({ childProps = {}, ...props }) => (
            <Table.Td
              {...props }
            />
          )
        }}
        head={{
          userid: { label: 'User ID' },
          email: { label: 'Email' },
          status: { label: 'Status' },
          actions: { label: 'Actions' }
        }}
        body={{
          userid: Span,
          email: Span,
          status: (entry) => (
            getStatusChip(entry.status.name)
          ),
          actions: (entry) => (
            Actions(entry)
          )
        }}
        entries={agency.members}
      />
    </div>
  )
}

export default AgencyMembers